import { DatepickerControlInterface } from '../components/datepicker/interfaces';

import { BaseControl } from './base-control';

export class DatepickerControl extends BaseControl<string | null> {
  minDate: string | null;
  maxDate: string | null;

  constructor(data: DatepickerControlInterface) {
    super(data);

    this.minDate = !data.minDate ? null : data.minDate;
    this.maxDate = !data.maxDate ? null : data.maxDate;
  }
}
